import React, { useContext, useEffect } from 'react';
import 'twin.macro';
import { AppContext, UserContext } from '../context';
import { Link, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { Small, TextLine, Title } from '../text';
import { LoginForm } from '../form';
import { Main } from '../sections';
import { ContactMenu } from '../menus';
import { LoadingDots } from '../loading';
import { MetaTags } from '../meta';
import { decodeURIComponentSafely, encodeProfileUrl } from '../../lib/helpers';
import { documentGetCookie } from '../../cookie';

export const LoginPage = () => {
  const navigate = useNavigate();
  const { user, initialized } = useContext(UserContext);
  const location = useLocation();
  const nsfwMessage = !!(location.state && location.state.nsfwHeader);
  const { slideIn, setSlideIn } = useContext(AppContext);
  const [sp] = useSearchParams();
  const { hash } = location;
  const next = sp.get('next') && !sp.get('next').includes('inloggen') ? sp.get('next') + hash : '/';
  const isProfileUserName = next.includes('/profiel/');
  const { 1: pathname = '', 2: username = '' } = next.split('/');
  const nextUri = isProfileUserName
    ? `/${pathname}/${encodeProfileUrl(username)}`
    : decodeURIComponentSafely(next);

  useEffect(() => {
    if (initialized && user) {
      navigate(nextUri, {
        replace: true,
        state: { accessToken: documentGetCookie('access_token') },
      });
    }
  }, [user]);

  return (
    <Main showAds={false} smallWidth>
      <MetaTags
        item={nsfwMessage && location.state.currentItem ? location.state.currentItem : null}
      />
      {!initialized && !user && <LoadingDots />}
      {initialized && !user && (
        <>
          <>
            <Title tw='mb-4'>
              {nsfwMessage ? 'DIT IS EEN NSFW ITEM' : 'Inloggen met jouw reaguurders account'}
            </Title>
            {nsfwMessage && (
              <TextLine tw='-mt-4'>Om dit item te kunnen bekijken moet je ingelogd zijn.</TextLine>
            )}
            <TextLine tw='block mb-8'>
              Of{' '}
              <Link to='/registreren' tw='text-brand'>
                registreer een account
              </Link>
            </TextLine>
            <LoginForm focused />
            <Small
              tw='block text-center mt-12 pb-6 font-bold uppercase text-icons cursor-pointer'
              data-menu='contact'
              onClick={() => {
                setSlideIn({
                  ...slideIn,
                  active: true,
                  fullwidth: false,
                  Component: () => <ContactMenu selectedOption={3} />,
                });
              }}
            >
              PROBLEMEN MET INLOGGEN?
            </Small>
          </>
        </>
      )}
    </Main>
  );
};
